import { Component, inject } from '@angular/core';
import { CrewTranslocoService } from './crew-transloco.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

/**
 * A reusable language switcher that renders as a single menu item with a submenu.
 * The trigger shows the active language flag and "Velg språk" label.
 * The submenu lists all available languages.
 *
 * Usage:
 * ```html
 * <mat-menu #menu="matMenu">
 *   <crew-language-switcher />
 *   ...other items...
 * </mat-menu>
 * ```
 */
@Component({
  selector: 'crew-language-switcher',
  standalone: true,
  imports: [MatMenuModule, MatIconModule, MatButtonModule],
  template: `
    <button mat-menu-item [matMenuTriggerFor]="langMenu" #langTrigger="matMenuTrigger"
            (mouseenter)="langTrigger.openMenu()">
      <span class="lang-flag">{{ translateService.activeLanguage().flag }}</span>
      <span>Velg språk</span>
    </button>
    <mat-menu #langMenu="matMenu">
      @for (lang of translateService.availableLanguages; track lang.code) {
        <button mat-menu-item (click)="translateService.setLang(lang.code)">
          <span class="lang-flag">{{ lang.flag }}</span>
          <span>{{ lang.name }}</span>
          @if (lang.code === translateService.activeLang()) {
            <mat-icon class="lang-active-icon">check</mat-icon>
          }
        </button>
      }
    </mat-menu>
  `,
  styles: [`
    .lang-flag {
      margin-right: 8px;
      font-size: 18px;
    }
    .lang-active-icon {
      margin-left: auto;
      color: var(--mat-primary);
    }
  `],
})
export class LanguageSwitcherComponent {
  readonly translateService: CrewTranslocoService = inject(CrewTranslocoService);
}
